import { Injector } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SimpleDialogData, openSimpleDialog } from '../../components/dialog';
import { GlobalSearchDialogComponent } from '../components/global-search-dialog/global-search-dialog.component';
import { GlobalSearchContext, GlobalSearchSelection } from '../models/global-search.model';

/**
 * Opens the global search palette.
 *
 * @param injector - The injector of the calling component (scopes the subscription to its lifetime).
 * @param context - Optional scope + per-call connector override; empty context uses the global connectors.
 * @param config - Optional `MatDialogConfig` overrides.
 * @returns {Observable<GlobalSearchSelection | undefined>} The committed selection, or `undefined` when dismissed.
 */
export function openGlobalSearch(
  injector: Injector,
  context: GlobalSearchContext = {},
  config?: Omit<
    MatDialogConfig<SimpleDialogData<GlobalSearchSelection, GlobalSearchContext>>,
    'data'
  >,
): Observable<GlobalSearchSelection | undefined> {
  return openSimpleDialog<GlobalSearchSelection, GlobalSearchContext>(
    injector,
    {
      content: GlobalSearchDialogComponent,
      context,
      headless: true,
      draggable: false,
    },
    {
      width: '40rem',
      maxWidth: '92vw',
      position: { top: '10vh' },
      panelClass: 'immo-global-search-panel',
      autoFocus: 'input',
      restoreFocus: true,
      ...config,
    },
  );
}
